import { useEffect, useMemo, useState } from 'react';

export function useIsMounted(): boolean {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => setIsMounted(true), []);

  return useMemo(() => isMounted, [isMounted]);
}
